import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IngredientDeleteParams } from '@app/mpp/model/ingredient-card-click-event';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformEnum, PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-ingredient-deletion-modal',
  templateUrl: './ingredient-deletion-modal.component.html',
  styleUrls: ['./ingredient-deletion-modal.component.scss'],
})
export class IngredientDeletionModalComponent {
  @Output() dismissEvent = new EventEmitter<void>();
  @Output() submitEvent = new EventEmitter<void>();
  @Input() platform: PlatformEnum;
  @Input() params: IngredientDeleteParams;
  platformRef = PlatformEnum;
  constructor(private translateService: TranslateService) {}

  dismissModal() {
    this.dismissEvent.next();
  }

  confirmDeletion() {
    this.submitEvent.next();
  }
}
